import { FormController } from '../classes/form-controller';
const axios = require('axios');

export default class extends FormController {
	static targets = ['form', 'formContainer', 'field', 'input', 'successNotice', 'emailPlaceholder', 'mobileButtonContainer'];

	connect() {
		// Call connect from FormController
		super.connect();

		document.querySelector('[data-job-alert-form-open-mobile]').addEventListener('click', this.openMobileForm);
	}

	/**
	 * Submit Job Alert form.
	 *
	 * @param {Event} e
	 */
	submit(e) {
		e.preventDefault();
		const formData = new FormData(this.formTarget);

		this.formTarget.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
				}

				if (response.data.status == 'success') {
					this.formTarget.reset();
					this.emailPlaceholderTarget.innerHTML = response.data.email;
					this.formTarget.classList.add('hidden');
					this.successNoticeTarget.classList.remove('hidden');
				}
				this.formTarget.removeAttribute('data-group-loading');
			})
			.catch((error) => {
				console.log(error);
				this.formTarget.removeAttribute('data-group-loading');
			});
	}

	/**
	 * Reset Job Alert form.
	 *
	 * @param {Event} e
	 */
	reset(e) {
		e.preventDefault();

		this.formTarget.classList.remove('hidden');
		this.successNoticeTarget.classList.add('hidden');
	}

	openMobileForm(e) {
		e.preventDefault();

		if (e.target.getAttribute('data-group-toggle')) {
			e.target.removeAttribute('data-group-toggle');
			document.querySelector('[data-job-alert-form-mobile').removeAttribute('data-toggle');
		} else {
			e.target.setAttribute('data-group-toggle', true);
			document.querySelector('[data-job-alert-form-mobile').setAttribute('data-toggle', true);
		}
	}
}
